import React from 'react';
import { useNavigate } from 'react-router-dom';
import DOMPurify from 'dompurify';
import LocalIcon from './LocalIcon';

const PoiCardList = ({ 
  poi, 
  taxonomyData, 
  distance
}) => {
  const navigate = useNavigate();

  return (
    <div className="w-100 p-0"> 
      {/* Immagine */}
      <div style={{ height: '250px', width: '100%' }}>
        <img 
          src={poi.field_immagini?.[0]?.url} 
          className="h-100"
          alt={poi.title[0].value}
          loading="lazy"
          decoding="async"
          style={{ 
            objectFit: 'cover',
            display: 'block' ,
            width:'102dvw' ,
            marginLeft: '-16px'            /*borderTopLeftRadius: '16px',
            borderTopRightRadius: '16px'*/
          }}
        />
      </div>

      {/* Contenuto testuale */}
      <div className="py-3">
        {/* Categoria con icona */}
        <div className="d-flex justify-content-start  mb-1">
          {taxonomyData[poi.field_tipologia_poi?.[0]?.target_id]?.icon && (
            <img 
              src={taxonomyData[poi.field_tipologia_poi[0].target_id].icon}
              alt={taxonomyData[poi.field_tipologia_poi[0].target_id].title}
              style={{ width: '20px', height: '20px' }}
              className="me-1"
            />
          )}
          <span className="small text-muted">
            {taxonomyData[poi.field_tipologia_poi?.[0]?.target_id]?.title || 'Punto di interesse'}
          </span>
        </div>

        {/* Titolo */}
        <h5 className="fw-bold mb-2">
          {poi.title[0].value}
        </h5>

        {/* Indirizzo */}
        {poi.field_indirizzo && (
          <p className="mb-2 text-muted" style={{ fontSize: '0.875rem' }}>
            <LocalIcon icon="location_on" className="align-bottom me-1" style={{ fontSize: '1.1rem' }} />
            {poi.field_indirizzo[0]?.value}
          </p>
        )}

        {/* Descrizione breve */}
        {poi.field_descrizione_breve && (
          <div className="mb-3" 
            style={{ fontSize: '0.875rem' }}
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(poi.field_descrizione_breve[0]?.value || '')
            }}
          />
        )}

        {/* Distanza e bottone */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <p className="mb-0" style={{ fontSize: '0.875rem' }}>
            <LocalIcon icon="near_me" className="align-bottom me-1" style={{ fontSize: '1.1rem' }} />
            Distanza <span className="fw-bold">{distance}</span>
          </p>
          <button 
            onClick={() => navigate(`/poi/${poi.nid[0].value}`)}
            className="btn btn-white border rounded-pill py-1 px-3 d-flex align-items-center shadow-sm"
            style={{ fontSize: '0.875rem' }}
          >
            Vai alla scheda
            
          </button>
        </div>
      </div>
    </div>
  );
};

export default PoiCardList;